import { merchantService } from "../components/utils/models/MerchantService";
import { PostMerchantRequestField } from "../components/utils/models/PostMerchantRequestField";
import { Address } from "../components/utils/models/address";
import { DomainEvent } from "../components/utils/models/domainEvent";
import { Card } from "../pages/home/models";

export class PostMerchantFormRequest {
  
  form! : PostMerchantRequestField;
  
  public constructor(fields: PostMerchantRequestField)
  {
    this.MapFieldObjectToClassProperties(fields);
  }

  public MapFieldObjectToClassProperties(fields: PostMerchantRequestField): void
  {
    if (fields) {

      this.form = {
        // this.form.mer = fields.entitytype || this.form.MerchantCategory;
        companyName : fields.companyName,
        MerchantId : fields.MerchantId,
        KeycloakUserId : fields.KeycloakUserId,
        registrationNumber : fields.registrationNumber ,
        sacraNumber : fields.sacraNumber ,
        ncrRegistrationNumber : fields.NCRRegistrationNumber,
        contactName: fields.contactName ,
        contactMiddleName: fields.contactMiddleName ,
        contactLastName: fields.contactSurname ,
        contactPhone: fields.contactPhoneNumber ,
        contactEmail:  fields.contactEmail ,
        accountStatus:  fields.accountStatus ,
        accountNumber : fields.accountNumber,
        bankname : fields.bankname,
        branchcode : fields.branchcode,
        bankcode : fields.bankcode,
        merchantCategory : fields.merchantCategory,
        walletNumber : fields.walletNumber,
        phoenixId : fields.phoenixId
      };


      if(fields.address)
      {
          this.form.address = fields.address;
      }

      if(fields.merchantServices)
      {
        this.form.merchantServices = fields.merchantServices;
      }

      if(fields.wallet)
      {
        this.form.wallet = fields.wallet;
      }

      if(fields.documents){

        this.form.documents = fields.documents;
      }
      
    }

  }


}



